/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { RouteObject } from 'react-router'
import { LoaderFunctionArgs } from 'react-router-dom'
import EstateFormPage from './EstateFormPage'
import EstateListPage from './EstateListPage'
import EstateMandateListPage from './EstateMandateListPage'
import EstateProspectingListPage from './EstateProspectingListPage'
import EstateLeaseListPage from './EstateLeaseListPage'
import EstateInterventionListPage from './EstateInterventionListPage'
import { fetchEstate } from '../../lib/rest/estateAPIClient'
import RouteLoaderData from '../../../../client/js/components/RouteLoaderData'

function estateLoader (args: LoaderFunctionArgs) {
  const { params } = args
  return fetchEstate(Number(params.id))
}

export const estateRoutes: RouteObject[] = [
  {
    index: true,
    element: <EstateListPage />
  },
  {
    path: 'create',
    element: <EstateFormPage />
  },
  {
    path: ':id/*',
    element: <RouteLoaderData
      queryKey={['estate']}
      loader={estateLoader}
    />,
    children: [
      {
        path: 'edit',
        element: <EstateFormPage />
      },
      {
        path: 'interventions',
        element: <EstateInterventionListPage />
      },
      {
        path: 'leases',
        element: <EstateLeaseListPage />
      },
      {
        path: 'mandates',
        element: <EstateMandateListPage />
      },
      {
        path: 'prospecting',
        element: <EstateProspectingListPage />
      }
    ]
  }
]
